import { EntityBase, Var } from "addeus-common-library/stores/firestore";

export enum IconName {
    Gite = "gite",
    Groups = "groups",
    BakeryDining = "bakery_dining",
    FilterVintage = "filter_vintage",
    Cookie = "cookie",
    Restaurant = "restaurant",
    LocalSmall = "local_mall",
    StoreFront = "storefront",
    Eco = "eco",
    RocketLaunch = "rocket_launch",
    Fastfood = "fastfood",
    AssignmentInd = "assignment_ind",
}

export enum IconColor {
    Red = "#f18086",
    Pink = "#fad3d6",
    Orange = "#fcae66",
    Green = "#B4D59E",
    Blue = "#70aed5",
    Yellow = "#e3e276",
    Purple = "#9fa3d0",
    Brown = "#c29979",
}

export class Icon extends EntityBase {
    @Var(IconName)
    name: IconName = IconName.Person;

    @Var(IconColor)
    color: IconColor = IconColor.Pink;
}

export const DarkModeColorBrightness = 0.7;
